import { useCallback } from "react";

import debounce from "lodash/debounce";

import useLatestValue from "app/custom-hooks/useLatestValue";

const DEBOUNCE_TIMEOUT = 300;

type DebouncedCallback = (...args: unknown[]) => void & {
    cancel(): void; // lodash debounce method
};

const useStatefulDebouncedCallback = <S, T extends (...args: unknown[]) => unknown>(
    currentState: S,
    callbackFn: T,
    timeout = DEBOUNCE_TIMEOUT,
): DebouncedCallback => {
    const stateRef = useLatestValue(currentState);
    const funcRef = useLatestValue(callbackFn);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    return useCallback(
        debounce((...args: unknown[]) => funcRef.current(...args, stateRef.current), timeout) as DebouncedCallback,
        [timeout],
    );
};

export default useStatefulDebouncedCallback;
